import { useState, useEffect } from 'react';
import { formatInputAmount } from '../../../util/EfupUtility';
import './AmountRange.css';

export const AmountRange = props => {

    let startAmount = props.startAmount
    let endAmount = props.endAmount
    const [isUsingRange, setIsUsingRange] = useState(false)

    const {minAndMaxRequired, customClasses, onStartChange, onEndChange, errors, validator} = props;
    const inputContainerClasses = "efup-amount-range " 
        + customClasses?.inputContainer
        + (errors ? ' cb-input-error' : '')

    // Effect to set isUsingRange state if the parent component sent us an endAmount on first render
    useEffect(() => {
        if (endAmount) {
            setIsUsingRange(true)
        }
    }, [endAmount])

    function handleStartAmountChange(newStartAmount) {
        if (onStartChange) {
            onStartChange(newStartAmount)
        }
    }

    function handleEndAmountChange(newEndAmount) {
        if (onEndChange) {
            onEndChange(newEndAmount)
        }
    }

    function handleAddRange() {
        setIsUsingRange(true)
    }

    function handleRemoveRange() {
        setIsUsingRange(false)
        if (onEndChange) {
            onEndChange('')
            
            // Rerun the validation with an empty end amount
            // This will remove errors pertaining to end amount when the user removes the end amount input
            validator(startAmount, '')
        }
    }

    return (
        <div>
            <div className={"efup-amount-range-input-container " + customClasses?.container} id="amountRange">
                <span className={inputContainerClasses}>
                    $
                    <input 
                        className={errors ? 'cb-input-error' : ''}
                        data-testid="amount-range-start-amount"
                        type="text"
                        maxLength="14"
                        value={startAmount}
                        onChange={e => handleStartAmountChange(formatInputAmount(e.target.value))} 
                    />
                </span>
                
                {/* If min and max are not required, and the user hasn't clicked "add range", then display "Add range" button */}
                {(!minAndMaxRequired && !isUsingRange) &&
                    <div  className="efup-amount-range-edit-range">
                        <span onClick={handleAddRange} data-testid="amount-range-add-range-button">+ Add Range</span>
                    </div>
                }

                {/* Display the endAmount input option if min and max are required, or if the user clicked "add range" */}
                {(minAndMaxRequired || isUsingRange) &&
                    <>
                        <span className={customClasses?.inputSeparator}> - </span>
                        <span className={inputContainerClasses}>
                            $
                            <input
                                className={errors ? 'cb-input-error' : ''}
                                data-testid="amount-range-end-amount"
                                type="text"
                                maxLength="14"
                                value={endAmount}
                                onChange={e => handleEndAmountChange(formatInputAmount(e.target.value))}
                            />
                        </span>
                    </>
                }

                {/* If min and max are not required, and the user hasn clicked "add range", then display "remove range" button  */}
                {(!minAndMaxRequired && isUsingRange) &&
                    <>
                        <div className="efup-amount-range-edit-range remove">
                                <span onClick={handleRemoveRange} data-testid="amount-range-remove-range-button">- Remove Range</span>
                        </div>
                    </>
                }
            </div>
            {errors && (
                <div className="cb-input-error" data-testid="amount-range-errors">{errors}</div>
            )} 
        </div>
    )
}
